import Resource from '@/api/Resource';
import Platform from './Platform';
import Role from './Role';

const userStatuses = {
  'active': { color: 'is-success', icon: 'check-circle', 'name': 'Активный' },
  'archive': { color: 'is-dark', icon: 'minus-circle', 'name': 'В архиве' },
};

const unknownUserStatus = { color: 'is-danger', icon: 'help' };

export default class extends Resource {
  $name = 'users';

  $defaults() {
    return {
      id: null,
      status: 'active',
      status_label: 'Активный',
      role_id: 0,
      first_name: '',
      last_name: '',
      patronymic: '',
      email: '',
      password: '',
      is_send_password: false,
      platform_id: 0,
      external_id: 0,
      created_at: null,
    };
  }

  $fill({ platform, role }) {
    if (platform) {
      this.platform = new Platform(platform);
    }

    if (role) {
      this.role = new Role(role);
    }
  }

  get fullName() {
    return `${this.$.last_name || ''} ${this.$.first_name || ''} ${this.$.patronymic || ''}`.trim();
  }

  get fullNameShort() {
    return `${this.$.first_name || ''} ${this.$.last_name || ''}`.trim();
  }

  get isAdmin() {
    return this.role_id === 1;
  }

  get isSupport() {
    return this.isAdmin;
  }

  get statusLabel() {
    return userStatuses[this.status] || unknownUserStatus;
  }

  get statuses() {
    return userStatuses;
  }

  can(name, action = null) {
    return this.role ? this.role.can(name, action) : false;
  }
}
